
































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { SwButton } from '@libs-uuif/shared/sw-button';
import  ItemContent  from './item-content.vue';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
import { currentUserKey } from '@/shared/msw-constants';
import RegexValidators from '../../../shared/regex-validators';

const cssPrefix = 'create-user';

@Component({
  components: {
    ItemContent,
    SwButton,
    SwCheckbox,
    SwIcon,
    SwForm,
    SwFormRow,
    SwSelect,
    SwScrollView,
    SwTextfield,
    SwSpinningProgress,
  },  directives: {
    tooltip,
  },
})
export default class CreateUser extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  selectedUserList: any = [];
  @Prop({ type: Array, required: true })
  usersList: any;
  @Prop()
  showLoading : any;
  @Prop({ required: false, type: Boolean })
  inviteUserPopup: any;
  @Prop({ required: false, type: Boolean })
  enbleUserInvite: any;
  @Prop()
  createUserModal: any;

  searchUserString: string = '';
  // usersListResponse: any = [];
  filterUserData: any = [];
  enableInviteUserFlag: boolean = false;
  inviteUser: string = '';
  inValidEmail: boolean = false;
  inviteFirstNameUser: string = '';
  inviteLastNameUser: string = '';
  disableAddButton: boolean = true;
  disableInviteButton: boolean = true;
  enableInviteUserToolTip: boolean = false;
  enableInviteFirstNameUserToolTip: boolean = false;
  enableInviteLastNameUserToolTip: boolean = false;
  inviteUserToolTipContent: string = '';
  inviteUserFirstNameToolTipContent: string = '';
  inviteUserLastNameToolTipContent: string = '';
  inviteContactTypeUser: string = '';
  showToaster: boolean = false;
  customerRole: string = '10015';
  contactTypeOptions: SelectOption[] = [
    { id:'10001', label: 'Employee', value: '10001' },
    { id: this.customerRole, label: 'Reseller/Customer', value: this.customerRole },
  ];
  showErrorMsg = false;
  showInitialLoader : boolean = false;
  isLoadingPartialDataset: boolean = false;
  partialData: any[] = [];

  @Watch('createUserModal')
  resetValidationMsg() {
    this.searchUserString = '';
    if (!this.createUserModal) {
      this.inviteUser = '';
      this.inviteFirstNameUser = '';
      this.inviteLastNameUser = '';
      this.showErrorMsg = this.showToaster = false;
    }
  }

  @Watch('enbleUserInvite')
  resetPopup() {
    this.enableInviteUserFlag = false;
    this.inviteContactTypeUser = '';
  }

  @Watch('showLoading')
  setInitialLoader() {
    if (this.showLoading) {
      this.showInitialLoader = true;
      // this.usersListResponse = [];
      this.filterUserData = [];
      this.inviteUser = '';
      this.inviteFirstNameUser = '';
      this.inviteLastNameUser = '';
      this.showErrorMsg =  this.showToaster = false;
      this.inviteContactTypeUser = '';
    } else {
      this.showInitialLoader = false;
      this.inviteContactTypeUser = '';
      this.showErrorMsg = false;
    }
  }
  contactTypeChanged() {
    this.showToaster = false;
    if (this.inviteContactTypeUser !== '10001') {
      this.inviteFirstNameUser = '';
      this.inviteLastNameUser = '';
    }
    // this.onEnterInviteUser();
  }
  closeSearchUsers() {
    this.loadUsers();
    this.searchUsers(this.filterUserData);
  }

  searchUsers(data: any) {
    // this.searchUserString = this.searchUserString.trimRight();
    if (this.searchUserString !== '') {
      this.filterUserData = this.filterUserData.filter((list: any) => list.fullName.toLocaleLowerCase()
      .includes(this.searchUserString.toLocaleLowerCase()
      .trimRight()) || list.emailAddress.toLocaleLowerCase()
      .includes(this.searchUserString.toLocaleLowerCase()
      .trimRight()));
      // console.log('Post Malone:: ', this.filterUserData, data)
    } else {
      this.filterUserData = data;
      // console.log('Post Malone:: ', this.filterUserData, data);
      this.loadUsers();
    }
    this.partialData = this.filterUserData.slice(0, 50);
    // this.searchUserString = '';
  }

  created() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained.roles[0] === 'CUSTOMER') {
      this.customerRole = '10015';
    } else {
      this.customerRole = '10006';
    }
    this.searchUserString = '';
    this.loadUsers();
  }

  @Watch('usersList')
  loadUsers() {
    // console.warn('tetst');
    // this.inviteUser = '';
    // this.inviteFirstNameUser = '';
    // this.inviteLastNameUser = '';
    // this.enableInviteUserFlag = false;
    // this.disableAddButton = false;
    this.filterUserData = this.usersList;
    this.partialData = this.filterUserData.slice(0, 50);
    if (this.selectedUserList.length > 0) {
      this.disableAddButton = false;
    } else {
      this.disableAddButton = true;
    }
  }
  onSelectUsers() {
    // console.log(this.selectedUserList);
    // this.selectedUserList = data;
    if (this.selectedUserList.length > 0) {
      this.disableAddButton = false;
    } else {
      this.disableAddButton = true;
    }
  }

  get contactTypeTooltip(): TooltipDirValues {
    let content = '';
    content = String(this.$t('userGroups.contentTypeTooltip'));
    return {
      content,
      placement: 'top',
      compact: true,
      maxWidth: 275,
      includePopperForHover: true,
      doAnimation: true,
    };
  }

  enableInviteUser() {
    console.warn('calling emit unction');
    this.$emit('changePopupStyle', 'YES');
    this.enableInviteUserFlag = true;
    this.disableInviteButton = true;
  }

  get getValidationFlag() {
    let flag = false;
    if (this.inviteContactTypeUser === '10001') flag = (this.inviteUser !== '') && (this.inviteFirstNameUser !== '') && (this.inviteLastNameUser !== '');
    else flag = (this.inviteUser !== '');
    return flag;
  }

  checkEmail() {
    const regexStr =  new RegExp(RegexValidators.email);
    this.inValidEmail = !regexStr.test(this.inviteUser);
  }

  onInvite() {
    this.showErrorMsg = true;
    if (this.inviteContactTypeUser === '') {
      this.showToaster = true;
      return;
    }
    if (this.getValidationFlag) {
      if (this.inviteContactTypeUser === '10001') {
        if (this.inviteFirstNameUser.trim() === '') {
          this.enableInviteFirstNameUserToolTip = true;
          this.inviteUserFirstNameToolTipContent = 'Enter first name';
        } else {
          this.enableInviteFirstNameUserToolTip = false;
        }

        if (this.inviteLastNameUser.trim() === '') {
          this.enableInviteLastNameUserToolTip = true;
          this.inviteUserLastNameToolTipContent = 'Enter last name';
        } else {
          this.enableInviteLastNameUserToolTip = false;
        }
      }
      if (this.inviteUser.trim() !== '') {
        // tslint:disable-next-line:max-line-length
        if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.inviteUser)) {
          this.enableInviteUserToolTip = true;
          this.inviteUserToolTipContent = 'Enter valid email address.';
        } else {
          this.enableInviteUserToolTip = false;
          const invitedUserExist =
          this.filterUserData.find((item: any) => item.emailAddress.toLocaleLowerCase() === this.inviteUser.toLocaleLowerCase()) !== undefined ?
          this.filterUserData.find((item: any) => item.emailAddress.toLocaleLowerCase() === this.inviteUser.toLocaleLowerCase()).emailAddress : '';
          if (invitedUserExist.toLocaleLowerCase() === this.inviteUser.toLocaleLowerCase()) {
            this.enableInviteUserToolTip = true;
            this.enableInviteUserFlag = true;
            this.inviteUserToolTipContent = 'This email address already exists.';
          } else {
            if ((this.inviteContactTypeUser !== '10001') || (this.inviteFirstNameUser.trim() !== '' && this.inviteLastNameUser.trim() !== '')) {
              this.enableInviteUserToolTip = false;
              const tempUser = {
                emailAddress: this.inviteUser,
                invited: true,
                firstName: this.inviteContactTypeUser === '10001' ? this.inviteFirstNameUser : '',
                lastName: this.inviteContactTypeUser === '10001' ? this.inviteLastNameUser : '',
                fullName: `${this.inviteFirstNameUser} ${this.inviteLastNameUser}`.trim(),
                contactTypeId: this.inviteContactTypeUser,
              };
              this.$emit('invite-user', tempUser);
              // this.usersListResponse.push({
              //   emailAddress: this.inviteUser,
              //   invited: true,
              //   firstName: this.inviteFirstNameUser,
              //   lastName: this.inviteLastNameUser,
              //   fullName: `${this.inviteFirstNameUser} ${this.inviteLastNameUser}`,
              //   contactTypeId: this.inviteContactTypeUser,
              // });
              // this.enableInviteUserFlag = false;
              // this.inviteUser = '';
              // this.inviteFirstNameUser = '';
              // this.inviteLastNameUser = '';
              // this.inviteContactTypeUser = '10001';
            }
          }
        }
      } else {
        this.enableInviteUserToolTip = true;
        this.inviteUserToolTipContent = 'Enter email address.';
      }
    }
  }

  addUsers() {
    this.$emit('selectedUsersList', this.selectedUserList);
    this.$emit('request-close');
    this.searchUserString = '';
    this.partialData = this.filterUserData.slice(0, 50);
    this.selectedUserList = [];
  }

  onEnterInviteUser() {
    this.inviteUser = this.inviteUser.trim();
    // if (this.filterUserData.find((item: any) => item.emailAddress === val) === val) {
    //   this.enableInviteUserToolTip = true;
    //   this.inviteUserToolTipContent = 'This Email Address already exists.';
    // } else {
    //   this.enableInviteUserToolTip = false;
    // }
    if (this.inviteUser.trim() !== '') {
      this.enableInviteUserToolTip = false;
    }
    this.checkEmail();
    // if (this.inviteUser.trim() !== '' && this.inviteContactTypeUser !== '10001') {
    //   this.disableInviteButton = false;
    // } else if (this.inviteUser.trim() !== '' && this.inviteFirstNameUser.trim() !== '' && this.inviteLastNameUser.trim() !== '') {
    //   this.disableInviteButton = false;
    // } else {
    //   this.disableInviteButton = true;
    // }
  }

  onEnterFirstNameInviteUser() {
    if (this.inviteFirstNameUser.trim() !== '') {
      this.enableInviteFirstNameUserToolTip = false;
    }
    // if (this.inviteUser.trim() !== '' && this.inviteFirstNameUser.trim() !== '' && this.inviteLastNameUser.trim() !== '') {
    //   this.disableInviteButton = false;
    // } else {
    //   this.disableInviteButton = true;
    // }
  }

  onEnterLastNameInviteUser() {
    if (this.inviteLastNameUser.trim() !== '') {
      this.enableInviteLastNameUserToolTip = false;
    }
    // if (this.inviteUser.trim() !== '' && this.inviteFirstNameUser.trim() !== '' && this.inviteLastNameUser.trim() !== '') {
    //   this.disableInviteButton = false;
    // } else {
    //   this.disableInviteButton = true;
    // }
  }

  get inviteUserTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enableInviteUserToolTip,
      placement: 'right',
      persistent: true,
      compact: true,
      content: this.inviteUserToolTipContent,
    };
  }
  get inviteUserFirstNameTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enableInviteFirstNameUserToolTip,
      placement: 'right',
      persistent: true,
      compact: true,
      content: this.inviteUserFirstNameToolTipContent,
    };
  }
  get inviteUserLastNameTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enableInviteLastNameUserToolTip,
      placement: 'right',
      persistent: true,
      compact: true,
      content: this.inviteUserLastNameToolTipContent,
    };
  }

  modalCloseUser() {
    this.enableInviteUserToolTip = false;
    this.$emit('request-close');
  }

  onCancelInvite() {
    this.$emit('changePopupStyle', 'NO');
    this.enableInviteUserFlag = false;
    this.inviteUser = '';
    this.inviteFirstNameUser = '';
    this.inviteLastNameUser = '';
    this.inviteContactTypeUser = '';
    this.enableInviteUserToolTip = false;
    this.enableInviteFirstNameUserToolTip = false;
    this.enableInviteLastNameUserToolTip = false;
    this.showErrorMsg = this.showToaster = false;
  }

  handleScroll(e: any) {
    // console.log(e);
    if (e.srcElement && (e.srcElement.scrollHeight - e.srcElement.scrollTop - e.srcElement.clientHeight < 1)) {
      // console.log('hit bottom');
      this.onLoadMore(20);
    }
  }

  private onLoadMore(minNumToLoad: number) {
    if (this.isLoadingPartialDataset) { return; }
    this.loadData(this.partialData.length, Math.max(minNumToLoad, 20));
  }

  private loadData(start: number, length: number) {
    if (length <= 0) { return Promise.resolve(0); }

    this.isLoadingPartialDataset = true;
    return new Promise<number>((resolve) => {
      setTimeout(
        () => {
          let count = 0;
          for (; count < length && (start + count) < this.filterUserData.length; count += 1) {
            this.partialData.push(this.filterUserData[start + count]);
          }
          this.isLoadingPartialDataset = false;
          resolve(count);
        },
        200,
      );
    });
  }
}
